module.exports = __webpack_public_path__ + "static/media/login-cover.97d5404c.svg";